import { isNullOrUndefined, safeParseJSON } from '../general-helpers';

export const setLocalStorageItem = (key, value) => {
    if (isNullOrUndefined(value)) {
        return;
    }

    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        throw error;
    }
};

export const getLocalStorageItem = (key, deleteItem = false) => {
    try {
        const item = safeParseJSON(localStorage.getItem(key));

        if (deleteItem) {
            localStorage.removeItem(key);
        }

        return item;
    } catch (error) {
        return undefined;
    }
};
